export default "__VITE_ASSET__BfFfdLtT__"